import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from "react-moment";
import 'moment/locale/ro';
import Parser from 'html-react-parser';
import {slugify} from '../../../SHARED/helpers/general.helper';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';

class LastNews extends Component {
    render() {
        return (
            <div className="last-news">
                <Link to={`/stire/${this.props.id}/${slugify(this.props.title)}`} className="white-text" >
                    <img src={ Parser(this.props.image) } alt={'Cinemap'} className="img-fluid w-100"/>
                </Link>
                <span className="last-news-date">
                    <Moment format="DD MMMM YYYY HH:mm" locale="ro" unix>
                        { this.props.date }
                    </Moment>
                </span>
                <span className="last-news-title">
                <Link to={`/stire/${this.props.id}/${slugify(this.props.title)}`} className="white-text">
                    { Parser(this.props.title) }
                </Link>
                </span>
                <span className="last-news-description">
                    { Parser(this.props.description.substr(0, 200)) }...
                </span>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps, {})(LastNews));



// WEBPACK FOOTER //
// ./src/FO/components/lastnews/lastnews.component.js